import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'brn-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
export class SnackBarComponent implements OnInit {
  message: string | undefined;
  type: 'error' | 'success' | 'info';

  constructor(public snackBarRef: MatSnackBarRef<SnackBarComponent>) {
    this.message =
      this.snackBarRef.containerInstance.snackBarConfig.announcementMessage;
    this.type = this.snackBarRef.containerInstance.snackBarConfig.data.type;
  }

  ngOnInit(): void {}
}
